import React from 'react';
import Menu from '../../components/globalComponents/headerMenu/menu';
import SocialIcons from '../../components/globalComponents/socialIcons/socialIcons';
import GradientLine from '../../components/globalComponents/gradientLine/gradientLine';
import Footer from '../../components/globalComponents/footer/footer';
import ServicesInfoHeader from '../../components/servicesInfoComponents/servicesInfoHeader/servicesInfoHeader';
import ServicesWonderaly from '../../components/servicesInfoComponents/servicesWonderaly/servicesWonderaly';
import ServicesInfoCompany from '../../components/servicesInfoComponents/servicesInfoCompany/servicesInfoCompany';
import ContactUs from '../../components/companyInfoComponents/contactUs/contactUs';
import './servicePage.scss';

const ServicePage = () => {
  return (
    <div>
      <Menu />
      <ServicesInfoHeader />
      <ServicesInfoCompany />
      <ServicesWonderaly />
      <ContactUs />
      <SocialIcons />
      <GradientLine />
      <Footer />
    </div>
  );
};

export default ServicePage;
